
<div class="flex-column align-items-center" :class="jel_getClassObject(content)">
  <!-- Afficher l'image et/ou le texte selon ce qui a été saisi dans Mangolia -->
  <!-- Si il y a une promo dans le store, on affiche cette promo -->
  <div v-if="isLienActif">
    <b-link v-bind="jel_getLienBinding(content.lien)">
      <b-img-lazy
        :src="jel_getFichierSrc(contentReel.image)"
        :alt="contentReel.altImage"
        class="w-50"
      />
    </b-link>
  </div>
  <div v-else>
    <b-img-lazy
      :src="jel_getFichierSrc(contentReel.image)"
      :alt="contentReel.altImage"
      class="w-50"
    />
  </div>

  <h1 :class="promoDetailClassObject">
    <span v-html="contentReel.titre"></span>
  </h1>
  <div v-html="contentReel.texte"></div>
  <Hyperlien v-if="contentReel.lien" :content="contentReel.lien" />
</div>
